module.exports = __webpack_public_path__ + "img/image-map-3-38c82f4c.png";